(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'ActuateOperationTimeVacuumController',
      ActuateOperationTimeVacuumController
    );

  /** @ngInject */
  function ActuateOperationTimeVacuumController(
    $scope,
    $mdDialog,
    data,
    sortArrayService
  ) {
    var vm = this;
    vm.disableInputs = true;
    vm.patternForHourInputs = '';

    init();

    vm.actuate = function () {
      data.actuators.forEach(function (actuator) {
        if (actuator.reference === 'VAC_START') {
          actuator.value = actuator.value.replace(/:/g, '-');
        } else if (actuator.reference === 'VAC_STOP') {
          actuator.value = actuator.value.replace(/:/g, '-');
        }
      });
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.change24hValue = function (form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_24H' && item.value !== 'false') {
          vm.disableInputs = true;
          vm.patternForHourInputs = '';
          resetInputs(form);
        } else if (item.reference === 'VAC_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        }
      });
    };

    function resetInputs(form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_START') {
          item.value = ' ';
        } else if (item.reference === 'VAC_STOP') {
          item.value = ' ';
        }
      });
      form.$invalid = false;
    }

    function init() {
      $scope.$on('$destroy', destroy);
      vm.currentDay = data.day;
      vm.data = sortArrayService.sortByGroupValue(data.actuators);
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_24H' && item.value !== 'false') {
          vm.disableInputs = true;
        } else if (item.reference === 'VAC_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        } else if (item.reference !== 'VAC_24H') {
          item.value = item.value.replace('-', ':');
        }
      });
    }

    function destroy() {}
  }
})();
